function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { shouldSeeProductsPricingPage } from "services/ab-tests/monetization-ab-tests-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import FeaturesTableComponent from "./features-table/features-table-component";
import ProductFeaturesTable from "./product-features-table/product-features-table";
import { StyledFeaturesTablePricingComponent } from "./features-table-pricing-component.scss.js";
class FeaturesTablePricingComponent extends PureComponent {
    componentDidUpdate() {
        this.checkIfShouldSeeProductsFeaturesTable();
    }
    checkIfShouldSeeProductsFeaturesTable() {
        const { productName, abTests, clusterId, hasStudentPlan, cookies, forcePricing, cloudfrontViewerCountry, isClusterMiniSitePage } = this.props;
        this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || shouldSeeProductsPricingPage({
            abTests,
            clusterId,
            hasStudentPlan,
            cookies,
            forcePricing,
            cloudfrontViewerCountry
        }));
    }
    render() {
        const { ignoreClusterConfig, isHomepagePricing } = this.props;
        return /*#__PURE__*/ _jsx(StyledFeaturesTablePricingComponent, {
            className: "features-table-pricing-component",
            children: this.shouldSeeProductsFeaturesTable || isHomepagePricing ? /*#__PURE__*/ _jsx(ProductFeaturesTable, _object_spread({}, this.props)) : /*#__PURE__*/ _jsx(FeaturesTableComponent, {
                ignoreClusterConfig: ignoreClusterConfig
            })
        });
    }
    constructor(props){
        super(props);
        this.checkIfShouldSeeProductsFeaturesTable();
    }
}
export default withAbTests(withGenericConfig(FeaturesTablePricingComponent));
